import { useAdvertGetById } from "./useAdvertGetById"

export const useAdvertIsActif = (id: string) => {
    const { data } = useAdvertGetById(id, true)

    return data?.advert?.actif
}